import Box from "@mui/material/Box/Box";
import {theme} from "../../themes/theme";

interface IItemDetailBody {
    title: string,
    detail: React.ReactNode;
    sx?: { marginTop?: string }
}

export const CustomItemDetailBody = ({title, detail, sx}: IItemDetailBody) => {
    return (
        <Box sx={{display: "flex", ...sx}}>
            <Box sx={{width: "7rem", fontWeight: theme.typography.fontWeightRegular, display:"flex", alignItems:"center"}}>
                <Box>
                    {title}
                </Box>
            </Box>
            <Box sx={{fontWeight: theme.typography.fontWeightLight}}>
                {detail}
            </Box>
        </Box>
    );
};